import { createContext, useContext } from "react";

/**
 * True while the plan is rendering inside the Full Plan PDF preview / print
 * export (printMode). Table-bearing sections read this to force their Card
 * view in the PDF, and glossary terms read it to render as real links.
 */
export const PrintModeContext = createContext(false);

export const usePrintMode = () => useContext(PrintModeContext);
